// extracted by mini-css-extract-plugin
export var dividerLine = "_7x-3";
export var itemImage = "_7x-9";
export var lightDivider = "_7x-4";
export var modalContent = "_7x-5";
export var modalContentCompact = "_7x-6";
export var productCard = "_7x-a";
export var productImage = "_7x-b";
export var productImageCompact = "_7x-7";
export var productImagePlaceholder = "_7x-c";
export var productImagePlaceholderCompact = "_7x-8";
export var progressBarBackground = "_7x-1";
export var progressBarContainer = "_7x-0";
export var progressBarFill = "_7x-2";